import './styles';

import {useEffect} from 'react';

import {Box, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

import {PaymentLinkLogo} from '@/app/main/paymentLink/components/PaymentLinkLogo/PaymentLinkLogo';
import {AppButtonVariant} from '@/app/shared-components';

import {SplitsPromoCard} from './components/SplitsPromoCard';
import {
  SplitsViewModelProvider,
  useSplitBillsViewModelProvider,
} from './SplitsViewModelContext';

function SplitsSuccessContent() {
  const {t} = useTranslation();

  const {
    inviterName,
    onGetAvatarImage,
    inApp,
    handleSplitWithMo,
    handleOpenAccount,
    alreadyPaid,
    onHandleConfirmPayment,
  } = useSplitBillsViewModelProvider();

  useEffect(() => {
    onHandleConfirmPayment();
    // Intentionally runs once on mount — confirm payment is a one-shot side-effect
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section
      className="splits-landing"
      style={{
        paddingLeft: 16,
        paddingRight: 16,
      }}>
      <Box className="splits-landing-container">
        <Box className="splits-landing-logo">
          <Box className="logo-container">
            <PaymentLinkLogo />
          </Box>
        </Box>
        {onGetAvatarImage(inviterName)}
        <Typography
          className="splits-confirmation-greeting"
          component="h1">
          {t('split_bills_page.success.all_set')}
        </Typography>
        <Typography className="splits-landing-description">
          {alreadyPaid
            ? t('split_bills_page.success.already_paid')
            : t('split_bills_page.success.payment_sent')}
        </Typography>
      </Box>
      <SplitsPromoCard
        inApp={inApp}
        handleSplitWithMo={handleSplitWithMo}
        handleOpenAccount={handleOpenAccount}
        buttonVariant={AppButtonVariant.onPrimary}
      />
    </section>
  );
}

const SplitsSuccessPage = () => (
  <SplitsViewModelProvider>
    <SplitsSuccessContent />
  </SplitsViewModelProvider>
);

export default SplitsSuccessPage;
